<template>
  <vs-row vs-type="flex" vs-w="12">
    <mobile-order :orderListIsActive="orderListIsActive" @close="orderListIsActive=false" @emitRefresh="refreshOrderQuantity" ref="mobileOrder"/>
    <vs-row vs-type="flex" vs-w="12" v-if="!lossMode">
      <vs-col vs-type="flex" vs-w="10" class="pl-2">
        
        <vs-button
          type="gradient"
          @click="onClickBreadCrumb(data, index)"
          class="breadCrumb-item px-3 my-1 mx-1"
          :color="index == currentBreadCrumbIndex ? 'primary' : 'secondary'"
          :class="index == currentBreadCrumbIndex ? '' : 'text-light'"
          icon-pack="feather"
          icon-after
          icon="icon-chevrons-right"
          v-for="(data, index) in breadCrumbItems"
          :key="data.id"
        >
          {{ data.name }}
        </vs-button>
      </vs-col>
      <vs-col  vs-type="flex" vs-w="1" class="pl-2">
        <button  @click="openMobileOrders()" class="mobile-order-button" :class="{ 'new-order': newOrder }">
          Siparişler {{ orderQuantity }}
        </button>
      </vs-col>
    </vs-row>
    <vs-row v-else vs-type="flex" vs-w="12">
      <vs-row vs-tpye="flex" vs-w="12" vs-justify="space-between">
        <vs-col
          vs-type="flex"
          vs-w="9"
          vs-justify="flex-start"
          vs-align="center"
          class="pt-5 pl-6"
        >
          <span
            v-if="lossTypeSelection"
            class="text-dark text-medium-small2 weight-600"
          >
            Zayi Seçim Ekranı
          </span>
          <vs-button
            v-else
            type="flat"
            @click="onClickBreadCrumb(data, index)"
            class="breadCrumb-item px-3"
            :color="index == currentBreadCrumbIndex ? 'primary' : 'secondary'"
            icon-pack="feather"
            icon-after
            icon="icon-chevrons-right"
            v-for="(data, index) in breadCrumbItems"
            :key="data.id"
          >
            {{ data.name }}
          </vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-w="3"
          vs-justify="flex-end"
          vs-align="center"
          class="pt-5 pr-3"
        >
          <vs-button
            @click="lossMode = false"
            color="white"
            class="text-dark sale-box-shadow half-friendly-border"
            size="small"
            icon-pack="feather"
            icon="icon-arrow-left"
          >
            Satışa Geri Dön
          </vs-button>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12">
        <vs-col
          vs-type="flex"
          vs-w="12"
          vs-justify="flex-start"
          vs-align="center"
          class="pl-5"
        >
          <div class="btn-group">
            <vs-button
              @click="lossTypeSelection = true"
              type="line"
              class="mr-1"
              :class="{
                'clicked-line-button bold text-primary weight-600': lossTypeSelection,
                'text-dark': !lossTypeSelection,
              }"
            >
              Zayi Hammadde Seçimi</vs-button
            >
            <vs-button
              @click="lossTypeSelection = false"
              type="line"
              class="ml-1"
              :class="{
                'clicked-line-button bold text-primary weight-600': !lossTypeSelection,
                'text-dark': lossTypeSelection,
              }"
            >
              Zayi Ürün Seçimi</vs-button
            >
          </div>
        </vs-col>
      </vs-row>
    </vs-row>

    <vs-row
      ref="productCategoryList"
      vs-type="flex"
      vs-w="10"
      id="dataList"
      :class="{ maxDataListHeight: !lossMode, maxDataListHeightLess: lossMode }"
      vs-justify="center"
      v-if="!(lossMode && lossTypeSelection) && !productDetailActive"
    >
      <vs-col vs-type="flex" vs-w="12" v-if="currentProductList.length == 0">
        <p>Ürün Bulunamadı.</p>
      </vs-col>
      <vs-button
        class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/4 category-product m-1 responsive sale-box-shadow"
        @click="onProductDetailClick(product)"
        color="transparent"
        v-for="product in currentProductList"
        :key="product.id"
      >
        <vs-row vs-type="flex" vs-w="12">
          <vs-row vs-type="flex" vs-w="12">
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
              <div class="flex items-center justify-center p-1">
                <img
                  :src="
                    product.imageUrl
                      ? $baseUrl + '/' + product.imageUrl
                      : productPlaceHolder
                  "
                  class="responsive"
                />
              </div>
            </vs-col>
          </vs-row>
          <vs-row
            vs-type="flex"
            vs-w="12"
            class="bg-white category-product-name-row py-2"
          >
            <vs-col vs-type="flex" vs-w="12" vs-justify="center">
              <p
                class="text-smaller block text-primary weight-600 category-product-name px-1"
              >
                {{ product.name }}
              </p>
              <p
                class="text-smaller italic block text-primary bold px-1"
                v-if="checkChildren(product) != null"
              >
                {{ checkChildren(product) }}
              </p>
            </vs-col>
          </vs-row>
        </vs-row>
      </vs-button>
    </vs-row>

    <vs-row vs-type="flex" vs-w="0.75" v-if="!(lossMode && lossTypeSelection)">
      <vs-col vs-type="flex" vs-w="12" vs-align="center">
        <div class="w-full">
          <vs-button
            @click="scrollTop"
            type="gradient"
            class="w-full bg-primary2 text-light mb-3"
            icon-pack="feather"
            icon="icon-chevron-up"
            color="transparent"
          />
          <vs-button
            @click="scrollDown"
            type="gradient"
            class="w-full bg-primary2 text-light mt-3"
            icon-pack="feather"
            icon="icon-chevron-down"
            color="transparent"
          />
        </div>
      </vs-col>
    </vs-row>

    <vs-row
      vs-type="flex"
      vs-w="12"
      v-if="lossMode && lossTypeSelection"
      class="px-6 pt-3"
    >
      <vs-row vs-type="flex" vs-w="12" class="pb-3">
        <vs-col vs-type="flex" vs-w="12" class="px-1">
          <vs-input
            id="saleStockFilter"
            v-model="stockNameFilter"
            class="w-full bg-white"
            icon-pack="feather"
            icon="icon-search"
            placeholder="Stok İsmi"
          />
        </vs-col>
      </vs-row>
      <vs-row
        id="cartStockNameList"
        vs-type="flex"
        vs-w="12"
        v-if="stocks.length > 0"
      >
        <vs-row
          class="cartLossStockNameEntry"
          v-show="!stock.isSelected"
          :class="{
            'bg-secondary2': indextr % 2 == 0,
            'bg-white2': indextr % 2 == 1,
          }"
          vs-type="flex"
          vs-w="12"
          v-for="(stock, indextr) in filteredStocks"
          :key="stock.id"
        >
          <vs-col
            vs-type="flex"
            vs-w="7"
            vs-align="center"
            vs-justify="flex-start"
          >
            <span class="text-dark text-smaller weight-600">
              {{ stock.name }}
            </span>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-w="2"
            vs-align="center"
            vs-justify="flex-start"
          >
            <span class="text-dark text-smaller weight-600">
              {{ stock.unit.name }}
            </span>
          </vs-col>
          <vs-col vs-type="flex" vs-w="2" vs-align="center">
            <vs-input
              :name="stock.id + '.Miktar'"
              :disabled="stock.isSelected"
              size="small"
              v-validate="{ regex: /^\d{0,10}(\.\d{0,10}){0,1}$/ }"
              v-model="stock.quantity"
              class="w-full"
              placeholder="Miktar"
            />
            <span
              class="text-danger text-xsmall"
              v-show="errors.has(stock.id + '.Miktar')"
              >{{ "Geçersiz Format" }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="1" vs-align="center" vs-justify="center">
            <vs-button
              v-if="
                stock.quantity != null &&
                stock.quantity > 0 &&
                !stock.isSelected
              "
              radius
              @click="setStockSelect(stock)"
              size="small"
              type="filled"
              color="success"
              icon-pack="feather"
              icon="icon-check"
            />
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-row>
</template>
<script>
import { getLossStockNameList } from "@/api/Loss.js";
import  { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import MobileOrder from "./MobileOrder.vue";
import {GetMobileOrderQuantity} from "@/api/ProductCategory.js";
export default {
  components: {
    MobileOrder
  },
  data() {
    return {
      productPlaceHolder: require("@/assets/images/products/product-kahve.png"),
      breadCrumbItems: [],
      currentBreadCrumbIndex: 0,
      breadCrumbId: 0,
      productDetailActive: false,
      stocks: [],
      stockNameFilter: null,
      filteredStocks: [],
      newOrder: false,
      orderQuantity:0,
      orderListIsActive: false,
    };
  },
  props: {
    productList: null,
  },
  computed: {
    hasNeedNavigationByQuestion() {
      return this.$store.getters["selfservice/hasNeedNavigationByQuestion"];
    },
    hasAnySelectedStockLoss() {
      let bool = this.stocks.some((x) => x.isSelected);
      return !bool;
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      },
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"];
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    currentProductList() {
      if (this.productList != null) {
        return this.breadCrumbItems.length > 0
          ? this.breadCrumbItems[this.currentBreadCrumbIndex].dataSet
          : [];
      } else {
        return [];
      }
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
  },
  watch: {
    hasNeedNavigationByQuestion(val) {
      if(val) {
        this.navigateByQuestion()
      }
    },
    stockNameFilter(val) {
      this.setStockFilter(val);
    },
    lossMode(val) {
      if (val) {
        if (this.stocks.length > 0) return;
        this.getLossStockNameList();
      }
    },
    isReset(val) {
      if (!val) return;
      this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
      this.$store.dispatch("selfservice/setSelectedProduct", null);
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$store.dispatch("selfservice/clearSelectedLossStocks");
      this.lossTypeSelection = true;
      this.onClickBreadCrumb(this.breadCrumbItems[0], 0);
      if (this.stocks.length > 0) {
        this.stocks.forEach((x) => {
          x.quantity = null;
          x.isSelected = false;
        });
      }
      this.isReset = false;
    },
    selectedLossStocks: {
      deep: true,
      handler(val) {
        let selectedStocks = this.stocks.filter((x) => x.isSelected);
        if (val && val.length == 0) {
          selectedStocks.forEach((x) => {
            x.isSelected = false;
            x.quantity = null;
          });
        } else if (
          val &&
          val.length > 0 &&
          val.length < selectedStocks.length
        ) {
          selectedStocks.forEach((x) => {
            if (!val.some((y) => y.id == x.id)) {
              x.isSelected = false;
              x.quantity = null;
            }
          });
        }
      },
    },
  },
  created: async function () {
    this.orderQuantity = await GetMobileOrderQuantity();
    if (this.orderQuantity > 0) {
      this.newOrder = true;
    }
  },
  mounted: function () {
    const connection =new HubConnectionBuilder().withUrl(process.env.VUE_APP_ROOT_API+'/hub',
{
    accessTokenFactory: () => {
      return localStorage.getItem("auth-token");
    }
  }).withAutomaticReconnect().build();
connection.start().then(() => {
});
connection.onreconnected((connectionId) => {
  console.log(`Bağlantı yenilendi. Yeni bağlantı ID'si: ${connectionId}`);
});

connection.serverTimeoutInMilliseconds = 30000; // 30 saniye

connection.keepAliveIntervalInMilliseconds = 5000; // 5 saniye
    connection.on("SendOrder", message => {
      this.newOrder = true;
       var audio = new Audio(process.env.VUE_APP_ORDER_AUDIO);
   audio.play();
      this.$vs.notify({
              color: "success",
              title: "Yeni sipariş geldi.",
              text: ""
            });
            
    });
    connection.on("OrderQuantityInBranch", message => {
      this.orderQuantity = message;
    });
    this.initializeComponent();
  },
  methods: {
    refreshOrderQuantity: async function () {
      this.orderQuantity = await GetMobileOrderQuantity();
    if (this.orderQuantity > 0) {
      this.newOrder = true;
    }
    },
    openMobileOrders(){
      this.newOrder=false;
      this.orderListIsActive = true;
      this.$refs.mobileOrder.getOrder();
       //window.open('/pages/MobileOrder', 'myWindow', 'width=800,height=600');
    },
    setStockSelect(stock) {
      stock.isSelected = true;
      this.$store.dispatch("selfservice/addSelectedLossStock", stock);
    },
    setStockFilter: _.debounce(function (val) {
      this.filteredStocks = this.stocks.filter((x) =>
        x.name.toLowerCase().includes(val.toLowerCase())
      );
    }, 500),
    getLossStockNameList() {
      getLossStockNameList()
        .then((res) => {
          if (res && res.status) {
            this.stocks = res.data;
            this.setStockFilter("");
          } else {
            this.$fire({
              title: "Hata : " + res.status,
            text: "Stok Listesi Bulunamadı !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Stok Listesi Bulunamadı !",
            });
          }
        })
        .catch((error) => {
          this.$fire({
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
          });
        });
    },
    scrollTop() {
      let element = document.getElementById("dataList");
      element.scrollBy(0, -100);
    },
    scrollDown() {
      let element = document.getElementById("dataList");
      element.scrollBy(0, 100);
    },
    checkChildren: function (product) {
      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          return product.children[0].price.toString() + "₺";
        }
      }
      return null;
    },

    initializeComponent: async function () {
      this.breadCrumbItems = [
        {
          name: "Kategoriler",
          id: this.breadCrumbId++,
          dataSet: this.productList,
        },
      ];
    },
    navigateByQuestion() {
      let navigationQuestion = this.$store.getters["selfservice/getNavigationQuestion"]
      this.onClickBreadCrumb(this.breadCrumbItems[0], 0);
      if(navigationQuestion.categoryId) {
        let category = this.currentProductList.find(x=> x.id === navigationQuestion.categoryId)
        this.onProductDetailClick(category);
        this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion")
      }

      if(navigationQuestion.productId) {
        let product = this.currentProductList.find(x=> x.id === navigationQuestion.productId)
        this.onProductDetailClick(product)
        this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion")
      }
    },
    onClickBreadCrumb: function (selectedBreadCrumb, index) {
      this.currentBreadCrumbIndex = index;
      this.breadCrumbItems.length = this.currentBreadCrumbIndex + 1;
      this.breadCrumbItems = [...this.breadCrumbItems];
    },
    onProductDetailClick: function (product) {
      let breadItem = {
        id: this.breadCrumbId++,
        name: product.name,
      };

      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          product.children[0].isSelected = true;
          this.$store.dispatch("selfservice/productSelectionCompleted", {
            product: product,
            sizeId: product.children[0].sizeId,
          });
          return;
        }
      }

      if (product.childCategories != null) {
        breadItem.dataSet = product.childCategories;
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.products != null) {
        breadItem.dataSet = product.products;
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.type) {
        this.SelectProduct(product);
      }
    },
    SelectProduct: function (product) {
      this.$store.dispatch("selfservice/setPreSelectedProduct", product);
    },
  },
};
</script>
<style>
.cartLossStockNameEntry .vs-inputx {
  border: none !important;
  border-bottom: 1px solid #00000030 !important;
  border-radius: 0;
  background-color: transparent !important;
  font-weight: 600;
}

.cartLossStockNameEntry {
  border-bottom: 1px solid #00000020;
  padding: 0.5rem;
}

.breadCrumb-item {
  font-weight: 600 !important;
  font-size: 1.15rem !important;
}

.breadCrumb-item:focus {
  color: whitesmoke;
}

#cartStockNameList {
  max-height: 73vh;
  overflow-y: auto;
  border-radius: 1rem;
  border: 1px solid #00000040;
}

#cartStockNameList::-webkit-scrollbar {
  width: 0;
  height: 0;
}

#dataList {
  overflow: scroll;
  margin-left: 20px;
}

.maxDataListHeightLess {
  max-height: 83.25vh;
}

.maxDataListHeight {
  max-height: 92.25vh;
}

#dataList::-webkit-scrollbar {
  height: 0 !important;
  width: 0 !important;
}
.category-product-name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.category-product .vs-button--text {
  display: inline !important;
}
.category-product {
  max-width: 175px;
  border-radius: 18px;
  padding: 0 !important;
  border: 1px solid #00000050;
}
.category-product img {
  max-width: 135px !important;
  max-height: 135px !important;
}

.scroll-buttons-col {
  height: fit-content;
  margin-top: auto;
  margin-bottom: auto;
}

.clicked-line-button .vs-button-linex {
  width: 100% !important;
}

#product-list {
  z-index: 20;
}
.category-product-name-row {
  border-top: 1px solid #00000050;
}
.swal2-container {
  z-index: 99999;
}
.mobile-order-button {
  background-color: #4c5baf; 
  border: none;
  color: white;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
}

.cart-count {
  background-color: #fff;
  color: #4CAF50;
  font-size: 14px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 50%;
  margin-left: 5px;
}
.new-order {
  background-color: #c91c1f;
        -webkit-border-radius: 60px;
        border-radius: 60px;
        border: none;
        color: #eeeeee;
        cursor: pointer;
        display: inline-block;
        font-family: sans-serif;
        font-size: 20px;
        padding: 5px 15px;
        text-align: center;
        text-decoration: none;
}
@keyframes glowing {
        0% {
          background-color: #a8051d;
          box-shadow: 0 0 5px #a8051d;
        }
        50% {
          background-color: #e8192a;
          box-shadow: 0 0 20px #e81919;
        }
        100% {
          background-color: #a80518;
          box-shadow: 0 0 5px #a80508;
        }
      }
      .button {
        animation: glowing 1300ms infinite;
      }

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.new-order {
        animation: glowing 1300ms infinite;
      }
</style>
